import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducers/rootReducer'
import thunkMiddleware from 'redux-thunk'
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase'
import firebase from 'firebase'

firebase.initializeApp({
    apiKey: 'AIzaSyCDiyTLeyuG9KVPkmleSue0ZoZ_xWeD1bs',
    authDomain: 'calendarapp-27652.firebaseapp.com',
    databaseURL: 'https://calendarapp-27652.firebaseio.com',
    storageBucket: 'calendarapp-27652.appspot.com'
})

const reduxFirebaseConfig = {
    userProfile: 'users',
    enableLogging: false
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancer = composeEnhancers(
    applyMiddleware(thunkMiddleware.withExtraArgument(getFirebase)),
    reactReduxFirebase(firebase, reduxFirebaseConfig)
)

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        enhancer
    )
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js